module.exports = __webpack_public_path__ + "img/user_icon.e7d2b7e9.svg";